{
    "locale": "pl-PL",
    "General": {
        "OrText": "Lub",
        "Title_MyHubert": "My Hubert",
        "Button_GoTo_MyHubert": "Przejdź do My Hubert"
    },
    "Header": {
        "ButtonText_CreateNewAccount": "Utwórz nowe konto",
        "ButtonText_SignInToYourAccount": "Zaloguj się na swoje konto",
        "ButtonText_StartInterviewWithoutSigningUp": "Rozpocznij rozmowę bez rejestracji",
        "ButtonText_StartInterviewWithoutSigningIn": "Rozpocznij rozmowę bez logowania",
        "Navlink_Dashboard": "Pulpit",
        "Navlink_MyInterviews": "Moje rozmowy",
        "Navlink_LearnWithHubert": "Ucz się z Hubertem",
        "Navlink_HelpCenter": "Centrum pomocy",
        "MyProfile": "Mój profil",
        "LogOut": "Wyloguj się"
    },
    "Login": {
        "MainTitle": "Zobacz wyniki swojej rozmowy z Hubertem",
        "Subtitle": "Zaloguj się, aby zobaczyć wyniki, otrzymać opinię, przeczytać porady i wiele więcej.",
        "LoginTitle": "Zaloguj się do swojego konta Hubert",
        "Label_Email": "Email",
        "Label_Password": "Hasło",
        "ButtonText_SignIn": "Zaloguj się",
        "ButtonText_ForgotPassword": "Nie pamiętasz hasła?",
        "ButtonText_ContinueWithGoogle": "Kontynuuj z Google",
        "OrSeparator": "Lub",
        "Error_Email_Required": "Email jest wymagany.",
        "Error_Email_Invalid": "Wprowadź prawidłowy email.",
        "Error_Password_Required": "Hasło jest wymagane.",
        "Error_Use_Same_Email_As_Interview": "Użyj tego samego adresu email, którego użyłeś podczas rozmowy."
    },
    "Registration": {
        "MainTitle": "Zobacz wyniki swojej rozmowy z Hubertem",
        "Subtitle": "Zarejestruj się, aby zobaczyć wyniki, otrzymać opinię, przeczytać porady i wiele więcej.",
        "RegistrationTitle": "Utwórz konto Hubert",
        "BenefitsBox_Title": "Możesz",
        "BenefitsBox_Point1": "Uzyskać dostęp do historii rozmów",
        "BenefitsBox_Point2": "Otrzymać informację zwrotną na temat rozmów",
        "BenefitsBox_Point3": "Ponownie wykorzystać odpowiedzi w nowych rozmowach",
        "BenefitsBox_Point4": "Otrzymać porady dotyczące rozmów",
        "BenefitsBox_Point5": "Czytać przewodniki kariery",
        "BenefitsBox_Point6": "I wiele więcej",
        "Label_FirstName": "Imię",
        "Label_LastName": "Nazwisko",
        "Label_Email": "Email",
        "Label_Password": "Hasło",
        "Label_PhoneNumber": "Numer telefonu",
        "Label_TermsOfService": "Akceptuję",
        "Label_TermsOfServiceLink": "Politykę prywatności i Regulamin",
        "Placeholder_CountryCode": "Wybierz kod kraju",
        "Placeholder_PhoneNumber": "Np.501234567",
        "HelpText_Password": "Hasło powinno mieć co najmniej 6 znaków.",
        "ButtonText_SignUp": "Zarejestruj się",
        "ButtonText_SignUpWithGoogle": "Zarejestruj się przez Google",
        "OrSeparator": "Lub",
        "Error_FirstName_Required": "Imię jest wymagane.",
        "Error_LastName_Required": "Nazwisko jest wymagane.",
        "Error_Email_Required": "Email jest wymagany.",
        "Error_Email_Invalid": "Wprowadź prawidłowy email.",
        "Error_Email_Exists": "Email jest już zajęty.",
        "Error_Password_Required": "Hasło jest wymagane.",
        "Error_Password_6_Characters": "Hasło musi mieć co najmniej 6 znaków.",
        "Error_PhoneNumber_Required": "Numer telefonu jest wymagany.",
        "Error_PhoneNumber_Invalid": "Numer telefonu jest nieprawidłowy.",
        "Error_PrivacyPolicyCheck_Required": "Musisz zaakceptować Politykę prywatności i Regulamin."
    },
    "RegistrationInviteEmail": {
        "Subtitle_BeforeInterviewCompleted": "Aby wziąć udział w rozmowie, musisz zaakceptować warunki korzystania z Huberta. Zaznacz pole, aby kontynuować.",
        "Subtitle_AfterInterviewCompleted": "Zarejestruj się, aby zobaczyć wyniki, otrzymać opinię, przeczytać porady i wiele więcej.",
        "PrivacyPolicyText": "Klikając „zarejestruj się” zgadzasz się na",
        "PrivacyPolicyLink": "Politykę prywatności i Regulamin",
        "ButtonText_SignUp": "Zarejestruj się i przejdź do rozmowy",
        "ButtonText_SignUpNormal": "Zarejestruj się",
        "ButtonText_SignInInstead": "Kliknij tutaj, aby się zalogować"
    },
    "LoginInviteEmail": {
        "Subtitle": "Zaloguj się, aby zobaczyć wyniki, otrzymać opinię, przeczytać porady i wiele więcej."
    },
    "AppMessages": {
        "internal-server-error": "Wystąpił nieoczekiwany błąd.",
        "invalid-credentials": "Nieprawidłowe dane logowania. Spróbuj ponownie.",
        "user-not-found": "Nieprawidłowe dane logowania. Spróbuj ponownie.",
        "account-not-found": "Nieprawidłowe konto. Spróbuj ponownie.",
        "verify-email-title": "Zweryfikuj swój email",
        "verify-email-subtitle": "Sprawdź email, aby zweryfikować konto.",
        "email-not-verified-title": "Email niezweryfikowany",
        "email-not-verified-subtitle": "Sprawdź email, aby zweryfikować konto.",
        "verifying-email-title": "Weryfikacja emaila",
        "verifying-email-subtitle": "Proszę czekać...",
        "sign-in-title": "Logowanie",
        "sign-in-subtitle": "Proszę czekać...",
        "server-error": "Coś poszło nie tak.",
        "hubert-user-exists": "Konto już istnieje.",
        "account-exists": "Konto już istnieje.",
        "email-verified": "Twój email został zweryfikowany.",
        "email-is-taken": "Email jest już zajęty.",
        "re-enter-password": "Użyj hasła, aby się zalogować",
        "password-reset": "Hasło zostało zmienione.",
        "re-enter-new-password": "Użyj nowego hasła, aby się zalogować",
        "invalid-invitation": "Nieprawidłowe zaproszenie.",
        "invalid-code": "Nieprawidłowy kod weryfikacyjny.",
        "email-already-verified": "Email już został zweryfikowany.",
        "email-mismatch-title": "Niepasujący email",
        "email-mismatch-subtitle": "Użyj tego samego adresu email, którego użyłeś w aplikacji o pracę."
    },
    "TransitionPage": {
        "loading-title": "Ładowanie...",
        "loading-subtitle": "Przygotowujemy twoje dane...",
        "logout-title": "Ładowanie...",
        "logout-subtitle": "Trwa wylogowywanie..."
    },
    "ImpersonationPage": {
        "loading-title": "Ładowanie...",
        "loading-subtitle": "Przygotowujemy twoje dane..."
    },
    "ProcessInvitation": {
        "loading-title": "Ładowanie...",
        "loading-subtitle": "Proszę czekać, ładujemy twoją rozmowę.",
        "InvitationNotFound": "Nie możemy znaleźć twojej rozmowy.",
        "InvitationExpired": "Link do rozmowy wygasł.",
        "InvitationExpired_Description1": "Otwórz rozmowę z",
        "InvitationExpired_Description2": "lub skontaktuj się z rekruterem.",
        "InvitationInvalid": "Link do zaproszenia jest nieprawidłowy.",
        "InterviewCompleted": "Rozmowa została już ukończona."
    },
    "Common": {
        "MyInterviews": {
            "Title": "Moje rozmowy",
            "TableHead_Employer": "Pracodawca",
            "TableHead_Job": "Stanowisko",
            "TableHead_Status": "Status",
            "TableHead_ApplicationDate": "Data aplikacji",
            "TableBody_StartInterview": "Rozmowa nie została ukończona. Kliknij tutaj, aby rozpocząć lub kontynuować.",
            "TableBody_NotScored": "Rozmowa została zakończona. Wyniki będą dostępne wkrótce.",
            "TableBody_Details": "Kliknij tutaj, aby zobaczyć wyniki rozmowy i więcej.",
            "ApplicationDate_Invited": "Zaproszono",
            "ApplicationDate_MinuteAgo": "minutę temu",
            "ApplicationDate_MinutesAgo": "minuty temu",
            "ApplicationDate_HourAgo": "godzinę temu",
            "ApplicationDate_HoursAgo": "godziny temu",
            "ApplicationDate_DayAgo": "dzień temu",
            "ApplicationDate_DaysAgo": "dni temu",
            "ButtonText_SeeAllInterviews": "Zobacz wszystkie rozmowy",
            "ButtonText_Details": "Szczegóły",
            "ButtonText_StartInterview": "Przejdź do rozmowy",
            "ButtonText_NotScored": "Oczekujące wyniki",
            "NoInterviews_Message": "Brak zapisów wcześniejszych lub nadchodzących rozmów."
        },
        "LatestJobPostings": {
            "NoJobPostings": "Obecnie brak ofert pracy. Sprawdź ponownie później."
        }
    },
    "Dashboard": {
        "MyCareer": {
            "Title": "Moja kariera",
            "Subtitle": "Wybierz rozmowę, aby zobaczyć ocenę i swoje perspektywy.",
            "MostRecentInterview": "Najnowsza rozmowa",
            "ToDo": "Do zrobienia",
            "NoOngoingInterviews_Title": "Brak nowych zaproszeń na rozmowę.",
            "NoOngoingInterviews_Subtitle": "Nowe rozmowy Hubert pojawią się tutaj, gdy zostaną zaplanowane przez rekruterów.",
            "NoRecentInterviews_Title": "Brak zapisów wcześniejszych rozmów.",
            "NoRecentInterviews_Subtitle": "Po zaproszeniu przez rekrutera, rozmowa pojawi się poniżej.",
            "ButtonText_StartInterview": "Przejdź do rozmowy",
            "ButtonText_NotScored": "Oczekujące wyniki",
            "ButtonText_Details": "Szczegóły"
        },
        "LearnWithHubert": {
            "Title": "Ucz się z Hubertem",
            "Subtitle": "Zdobądź porady, jak poprawić swoje umiejętności podczas rozmów i w pracy.",
            "PickedForMe": "Najnowsze artykuły",
            "ButtonText_SeeAllArticles": "Zobacz wszystkie artykuły"
        },
        "HubertTip": {
            "Title": "Wskazówka od Huberta",
            "Subtitle": "Szybsze rozmowy",
            "Description": "Aplikujesz na podobne stanowisko, na które wcześniej odbyłeś rozmowę z Hubertem? Możesz ponownie użyć swoich wcześniejszych odpowiedzi, aby zaoszczędzić czas.",
            "ButtonText_ReadMoreTips": "Zobacz więcej wskazówek"
        },
        "NewCandidateModalPopup": {
            "Title": "Wszystko gotowe!",
            "DescriptionLine1": "Twoje konto jest już aktywne.",
            "DescriptionLine2": "Zarządzaj rozmowami i profilem. Zobacz wyniki, otrzymaj opinie i dowiedz się więcej o rozmowach kwalifikacyjnych.",
            "ButtonText_LetsGo": "Zaczynamy"
        },
        "InterviewCompletedModal": {
            "Title": "Dobra robota!",
            "Subtitle": "Zakończyłeś rozmowę.",
            "Description": "Rekruterzy przeanalizują wszystkie aplikacje i przekażą informację zwrotną e-mailem lub telefonicznie, gdy tylko będą gotowi.",
            "ButtonText_Continue": "Kontynuuj"
        },
        "LatestJobPostings": {
            "Title": "Najnowsze oferty pracy",
            "Subtitle": "Zobacz oferty od partnerów Huberta, które niedawno się pojawiły."
        }
    },
    "MyInterviews": {
        "MyInterviewsSection_Title": "Moje rozmowy",
        "MyInterviewsSection_Subtitle": "Wybierz rozmowę, aby zobaczyć ocenę i swoje możliwości kariery.",
        "MyInterviewsSection_ToDo": "Do zrobienia"
    },
    "Interview": {
        "ButtonText_SeeAllInterviews": "Zobacz wszystkie rozmowy",
        "InterviewNotFound_Title": "Rozmowa niedostępna",
        "InterviewNotFound_Description": "Próbujesz uzyskać dostęp do rozmowy, która nie jest powiązana z Twoim kontem.",
        "ButtonText_GoToAllInterviews": "Przejdź do Moich rozmów",
        "InterviewDetails": {
            "Title": "Szczegóły rozmowy",
            "ForRole": "Na stanowisko",
            "InterviewCompletedOn": "Rozmowa ukończona dnia {{date}} o {{time}}"
        },
        "MyResult": {
            "Title": "Mój wynik",
            "Subtitle": "Ocenione dopasowanie",
            "ButtonText_LearnMore": "Zobacz, jak oceniane są Twoje odpowiedzi",
            "GotPotential_Title": "Masz potencjał, brakuje jednego wymogu",
            "GotPotential_Description": "Twoje odpowiedzi wskazują na duży potencjał dla tego typu stanowiska. Jednak na podstawie tej rozmowy możesz nie spełniać jednego lub więcej wymagań kwalifikacyjnych dla tej konkretnej pracy. Może to wpłynąć na dalsze kroki, w zależności od potrzeb rekrutera i liczby kandydatów. Jeśli nie zostaniesz zaproszony do kolejnego etapu, pamiętaj, że nie odzwierciedla to Twojego potencjału. Często chodzi o precyzyjne dopasowanie do specyficznych potrzeb roli. Sprawdź inne możliwości i wskazówki poniżej.",
            "GotPotential_DescriptionSecondary": "Ocena Huberta ma charakter doradczy. Decyzję podejmuje rekruter, a inne czynniki, takie jak liczba kandydatów, również mogą mieć wpływ na wynik.",
            "GreatMatch_Title": "Silne dopasowanie",
            "GreatMatch_Description": "Twoje odpowiedzi dobrze odpowiadają temu, czego zazwyczaj szukają rekruterzy na tym stanowisku, i spełniasz wymagania. Świetna robota. Rekruter przeanalizuje wszystkich kandydatów i zdecyduje o kolejnych krokach.",
            "GreatMatch_DescriptionSecondary": "Ocena Huberta ma charakter doradczy. Decyzję podejmuje rekruter, a inne czynniki, takie jak liczba kandydatów, również mogą mieć wpływ na wynik. Jeśli nie zostaniesz zaproszony do kolejnego etapu, pamiętaj, że nie odzwierciedla to Twojego potencjału. Często chodzi o precyzyjne dopasowanie do specyficznych potrzeb roli. Sprawdź inne możliwości i wskazówki poniżej.",
            "OkMatch_Title": "Kwalifikujesz się, dodaj więcej konkretów",
            "OkMatch_Description": "Spełniasz wymagania. Aby się wyróżnić, Twoje odpowiedzi mogą wymagać nieco więcej jasności i szczegółowości w porównaniu z tym, co zazwyczaj widzą rekruterzy. Przejrzyj swoje odpowiedzi poniżej, aby zobaczyć, gdzie dodanie konkretnego przykładu lub wyniku może podnieść Twój wynik.",
            "OkMatch_DescriptionSecondary": "Ocena Huberta ma charakter doradczy. Decyzję podejmuje rekruter, a inne czynniki, takie jak liczba kandydatów, również mogą mieć wpływ na wynik.",
            "NotClearMatch_Title": "Może nie być idealnym dopasowaniem (na razie)",
            "NotClearMatch_Description": "Na podstawie tej rozmowy Twoje odpowiedzi mogą być mniej zgodne z tym, czego szuka rekruter, lub możesz nie spełniać jednego lub więcej wymagań. Jeśli chcesz się poprawić, zacznij od pytań poniżej. Małe zmiany, więcej konkretów i jasne wyniki mogą zrobić dużą różnicę następnym razem.",
            "NotClearMatch_DescriptionSecondary": "Ocena Huberta ma charakter doradczy. Decyzję podejmuje rekruter, a inne czynniki, takie jak liczba kandydatów, również mogą mieć wpływ na wynik."
        },
        "ScoreBox": {
            "ProfessionalExperiences": "Doświadczenie zawodowe, motywacje i kompetencje",
            "QualifyingRequirements": "Wymagania kwalifikacyjne dla tej konkretnej pracy",
            "NotQualified_Title": "Obszary do poprawy",
            "NotQualified_Description": "Twoje odpowiedzi mogły być mniej szczegółowe lub mniej skoncentrowane na wynikach, niż oczekuje tego rekruter. Spójrz poniżej na zaznaczone miejsca, gdzie dodanie konkretnego przykładu, podjętych działań lub jasnego wyniku może wzmocnić Twoje odpowiedzi.",
            "GreatResults_Title": "Mocne odpowiedzi",
            "GreatResults_Description": "Twoje odpowiedzi wskazują, że dobrze pasujesz do tego typu roli i komunikujesz się jasno. Jeśli jakieś pytanie można poprawić, zobaczysz je wyróżnione poniżej.",
            "MeetingRequirements_Title": "Spełnienie wymagań",
            "MeetingRequirements_Description": "Twoje odpowiedzi wskazują, że spełniasz wymagania kwalifikacyjne ustalone przez rekrutera dla tej pracy. Dobra podstawa.",
            "NotAllExpectationsMet_Title": "Brak jednego lub więcej wymagań",
            "NotAllExpectationsMet_Description": "Na podstawie Twoich odpowiedzi możesz nie spełniać jednego lub więcej wymagań kwalifikacyjnych dla tej konkretnej pracy, takich jak certyfikaty, licencje, poziom wykształcenia lub lata doświadczenia.",
            "ButtonText_FindOutPossibleReasons": "Zobacz szczegóły"
        },
        "ScriptFromInterview": {
            "Title": "Przeczytaj całą rozmowę",
            "ButtonText_SeeWholeTranscript": "Przeczytaj rozmowę",
            "ButtonText_DeleteInterview": "Usuń rozmowę",
            "Loading_Title": "Ładowanie...",
            "Loading_Subtitle": "Proszę czekać, ładujemy transkrypcję Twojej rozmowy."
        },
        "HowToImproveAtInterviews": {
            "Title": "Jak poprawić się na rozmowach",
            "Subtitle_Questions": "Oto pytania, w których Twoja odpowiedź mogłaby zostać potencjalnie ulepszona.",
            "Subtitle_NoQuestions": "Nie oznaczono żadnych konkretnych odpowiedzi. Oto najlepsze sposoby na zwiększenie wpływu w tej roli.",
            "GreatMatch_Questions_Description": "Nawet przy silnym dopasowaniu, niektóre odpowiedzi można wzmocnić. Jeśli takie zidentyfikowaliśmy, znajdziesz je poniżej. Postępuj zgodnie z instrukcjami przed każdym pytaniem. Opisując sytuację, uwzględnij sytuację, co zrobiłeś i wynik. Unikaj bardzo krótkich odpowiedzi. Celuj w jasne i konkretne opisy, tak jak podczas rozmowy twarzą w twarz.",
            "GreatMatch_NoQuestions_Description": "Dobrze poradziłeś sobie z pytaniami. Świetna robota.",
            "OkMatch_Questions_Description": "Poniżej znajdziesz pytania, na które odpowiedź można by poprawić. Postępuj zgodnie z instrukcjami przed każdym pytaniem. Opisując sytuację, uwzględnij sytuację, co zrobiłeś i wynik. Unikaj bardzo krótkich odpowiedzi. Celuj w jasne i konkretne opisy, tak jak podczas rozmowy twarzą w twarz.",
            "OkMatch_NoQuestions_Description": "Twoje odpowiedzi były solidne, ale ta rola może być konkurencyjna. Oznacza to, że nawet dobre odpowiedzi mogą uplasować Cię w środku stawki.",
            "OkMatch_NoQuestions_DescriptionSecondary": "Następnym razem celuj w jasność i wpływ. Zacznij od wyniku, dodaj jeden prawdziwy przykład i bądź zwięzły, zazwyczaj 3 do 6 zdań. Bądź konkretny co do tego, co zrobiłeś, jak to zrobiłeś i co się zmieniło dzięki temu.",
            "GotPotential_Questions_Description": "Nawet jeśli wydajesz się silnym kandydatem na ten rodzaj pracy, niektóre odpowiedzi można wzmocnić. Jeśli takie zidentyfikowaliśmy, znajdziesz je poniżej. Postępuj zgodnie z instrukcjami przed każdym pytaniem. Opisując sytuację, uwzględnij sytuację, co zrobiłeś i wynik. Unikaj bardzo krótkich odpowiedzi. Celuj w jasne i konkretne opisy, tak jak podczas rozmowy twarzą w twarz.",
            "GotPotential_NoQuestions_Description": "Nie znaleźliśmy żadnych odpowiedzi wymagających znacznej poprawy w zakresie kompetencji zawodowych i motywacji. Wygląda na to, że dobrze odpowiedziałeś na te tematy.",
            "NotClearMatch_Questions_Description": "Poniżej znajdziesz pytania, na które odpowiedź można by poprawić. Postępuj zgodnie z instrukcjami przed każdym pytaniem. Opisując sytuację, uwzględnij sytuację, co zrobiłeś i wynik. Unikaj bardzo krótkich odpowiedzi. Celuj w jasne i konkretne opisy, tak jak podczas rozmowy twarzą w twarz.",
            "NotClearMatch_NoQuestions_Description": "Nie znaleźliśmy ani jednej „złej” odpowiedzi. Chodzi bardziej o ogólne dopasowanie do potrzeb tej roli. Jeśli konkurencja jest silna, małe luki mogą mieć znaczenie.",
            "NotClearMatch_NoQuestions_DescriptionSecondary": "W następnej rozmowie skup się na konkretach. Wybierz jeden przykład na pytanie, wyjaśnij swoje działania i podziel się wynikiem. Krótko i konkretnie zazwyczaj wygrywa z długo i ogólnie.",
            "Alert_WantMoreAdvice": "Chcesz więcej porad, jak dobrze wypaść na rozmowie z Hubertem?",
            "AlertLink_ExploreOurGeneralAdviceArticle": "Odkryj nasz artykuł z ogólnymi poradami"
        },
        "SimilarOffers": {
            "Title": "Podobne oferty"
        },
        "HowHubertScoresInterviews": {
            "Title": "Jak Hubert ocenia rozmowy?",
            "Description": "Poniżej znajduje się krótki opis, jak Hubert ocenia odpowiedzi. Dodaliśmy również sekcję Proces rekrutacyjny, aby wyjaśnić kolejne kroki po rozmowie z Hubertem.",
            "Tabs_PossibleOutcomes": "Możliwe wyniki",
            "Tabs_RecruitmentProcess": "Proces rekrutacyjny",
            "AssessedMatch_Title": "Ocenione dopasowanie",
            "AssessedMatch_Description": "Hubert ocenia, jak Twoje odpowiedzi wypadają ogólnie w porównaniu z tym, czego rekruterzy zazwyczaj szukają w tej roli. Razem z wymaganiami roli zobaczysz jeden z poniższych wyników.",
            "AssessedMatch_DescriptionSecondary": "Ocena Huberta ma charakter doradczy. Decyzję podejmuje rekruter, a inne czynniki, takie jak liczba kandydatów, również mogą mieć wpływ na wynik.",
            "GreatMatch_Title": "Silne dopasowanie",
            "GreatMatch_Description": "Twoje odpowiedzi dobrze odpowiadają temu, czego szukają rekruterzy, i spełniasz wymagania. Świetna robota. Rekruter przeanalizuje wszystkich kandydatów i zdecyduje o kolejnych krokach.",
            "GotPotential_Title": "Masz potencjał, brakuje wymogu",
            "GotPotential_Description": "Twoje odpowiedzi wskazują na duży potencjał. Jednak na podstawie tej rozmowy możesz nie spełniać jednego lub więcej wymagań kwalifikacyjnych. Może to wpłynąć na kolejne kroki, w zależności od potrzeb rekrutera.",
            "OkMatch_Title": "Kwalifikujesz się, dodaj więcej konkretów",
            "OkMatch_Description": "Spełniasz wymagania. Aby się wyróżnić, Twoje odpowiedzi mogą wymagać więcej jasności i szczegółowości. Wykorzystaj informację zwrotną z rozmowy, aby wzmocnić swoje przykłady w przyszłości.",
            "NotClearMatch_Title": "Może nie być idealnym dopasowaniem (na razie)",
            "NotClearMatch_Description": "Na podstawie tej rozmowy Twoje odpowiedzi mogą być mniej zgodne z tym, czego szuka rekruter, i możesz nie spełniać jednego lub więcej wymagań. Przejrzyj swoje odpowiedzi, aby zobaczyć, gdzie możesz dodać jasności i przykładów.",
            "ProfessionalExperiences_Title": "Doświadczenie zawodowe, motywacje i kompetencje",
            "ProfessionalExperiences_Description": "Są to pytania dotyczące Twoich wcześniejszych doświadczeń, motywacji do pracy i kompetencji istotnych dla roli. Rekruterzy decydują, które pytania są używane w rozmowie.",
            "GreatResults_Title": "Mocne odpowiedzi",
            "GreatResults_Description": "Twoje odpowiedzi wskazują, że dobrze pasujesz do tego typu roli i komunikujesz się jasno. Jeśli jakieś pytanie można poprawić, zobaczysz je wyróżnione.",
            "NotQualified_Title": "Obszary do poprawy",
            "NotQualified_Description": "Twoje odpowiedzi mogły być mniej szczegółowe lub mniej skoncentrowane na wynikach, niż oczekuje tego rekruter. Szukaj wyróżnionych miejsc, gdzie dodanie konkretnego przykładu lub jasnego wyniku może wzmocnić Twoje odpowiedzi.",
            "QualifyingRequirements_Title": "Podstawowe lub kwalifikacyjne wymagania",
            "QualifyingRequirements_Description": "Są to pytania, które rekruter ustalił jako wymagania kwalifikacyjne dla danej pracy. Na przykład wymagany certyfikat, prawo jazdy lub określony poziom doświadczenia.",
            "MeetingRequirements_Title": "Spełnienie wymagań",
            "MeetingRequirements_Description": "Twoje odpowiedzi wskazują, że spełniasz wymagania kwalifikacyjne ustalone przez rekrutera dla tej pracy. Dobra podstawa.",
            "NotAllExpectationsMet_Title": "Brak jednego lub więcej wymagań",
            "NotAllExpectationsMet_Description": "Na podstawie Twoich odpowiedzi możesz nie spełniać jednego lub więcej wymagań kwalifikacyjnych dla tej konkretnej pracy, takich jak certyfikaty, licencje, poziom wykształcenia lub lata doświadczenia.",
            "RecruitmentProcess_Title": "Proces rekrutacyjny",
            "RecruitmentProcess_Description": "Hubert jest zazwyczaj używany jako pierwszy krok w procesie rekrutacji z wieloma kandydatami. Umożliwia każdemu odbycie rozmowy i podzielenie się informacjami o sobie własnymi słowami. Ponieważ pytania są takie same dla wszystkich kandydatów, proces jest bardziej spójny. Hubert nie wykorzystuje również informacji takich jak wiek, płeć, pochodzenie etniczne, religia czy wygląd, co pomaga zmniejszyć ryzyko nieświadomych uprzedzeń.",
            "EventOne_Title": "Odbywasz rozmowę z Hubertem",
            "EventOne_Description": "Odbywasz rozmowę z Hubertem w czasie i miejscu, które najbardziej Ci odpowiadają. Nie ma ograniczeń czasowych, możesz zrobić przerwę w dowolnym momencie i kontynuować od miejsca, w którym skończyłeś.",
            "EventTwo_Title": "Twoja rozmowa jest oceniana",
            "EventTwo_Description": "Hubert ocenia Twoje odpowiedzi przy użyciu nowoczesnej technologii. Gdy tylko ocena zostanie zakończona, wyniki są widoczne dla Ciebie tutaj w My Hubert i dla rekrutera w jego systemie rekrutacyjnym.",
            "EventThree_Title": "Rekruter wybiera kandydatów do kolejnych etapów",
            "EventThree_Description": "Rekruterzy widzą w swoim systemie, kiedy dostępny jest nowy wynik rozmowy z Hubertem. Mogą wtedy przejrzeć Twoje odpowiedzi i ocenę Huberta. Na tej podstawie zdecydują o kolejnych krokach. Jeśli inni kandydaci są lepiej dopasowani, Twoja kandydatura może nie przejść do kolejnego etapu.",
            "ButtonText_Close": "Zamknij"
        }
    },
    "MyProfile": {
        "Title": "Mój profil",
        "MyDetails": {
            "Title": "Moje dane",
            "Label_FirstName": "Imię",
            "Label_LastName": "Nazwisko",
            "Label_Email": "Email",
            "Label_PhoneNumber": "Numer telefonu",
            "ButtonText_UpdateDetails": "Zaktualizuj dane",
            "Error_FirstName_Required": "Imię jest wymagane.",
            "Error_LastName_Required": "Nazwisko jest wymagane.",
            "Error_Email_Required": "Email jest wymagany.",
            "Error_Email_Invalid": "Wprowadź prawidłowy email.",
            "Error_PhoneNumber_Invalid": "Numer telefonu jest nieprawidłowy.",
            "Success_Details_Updated": "Profil zaktualizowany."
        },
        "ChangePassword": {
            "Title": "Zmień hasło",
            "Set_Password_Title": "Utwórz hasło",
            "Label_CurrentPassword": "Obecne hasło",
            "Label_NewPassword": "Nowe hasło",
            "Label_RepeatNewPassword": "Powtórz nowe hasło",
            "Alert_SignInAgain": "Zaloguj się ponownie, aby ustawić hasło.",
            "ButtonText_UpdatePassword": "Zaktualizuj hasło",
            "ButtonText_SetPassword": "Ustaw hasło",
            "ButtonText_SignInAgain": "Zaloguj się ponownie",
            "Error_CurrentPassword_Required": "Obecne hasło jest wymagane.",
            "Error_CurrentPassword_DoesntMatch": "Hasło nie pasuje do obecnego hasła.",
            "Error_NewPassword_Required": "Nowe hasło jest wymagane.",
            "Error_NewPassword_6_Characters": "Nowe hasło musi mieć co najmniej 6 znaków.",
            "Error_RepeatNewPassword_Required": "Powtórzenie nowego hasła jest wymagane.",
            "Error_RepeatNewPassword_DoesntMatch": "Hasło nie pasuje do nowego hasła.",
            "Success_Password_Changed": "Hasło zaktualizowane.",
            "Error_Invalid_CurrentPassword": "Nieprawidłowe obecne hasło."
        },
        "NotificationPreferences": {
            "Title": "Preferencje powiadomień",
            "Label_ReceiveUpdatesToggle": "Chcę otrzymywać aktualizacje od Huberta.",
            "Label_ReceiveUpdatesToggleHelpText": "Otrzymasz przewodniki kariery, porady dotyczące rozmów i więcej."
        },
        "AccountRemoval": {
            "Title": "Usuwanie konta",
            "ButtonText_RemoveMyAccount": "Usuń moje konto"
        }
    },
    "PreInterviewPage": {
        "Title_Hello": "Witaj",
        "Subtitle": "Zaraz rozpoczniesz swoją rozmowę o pracę.",
        "TipBox_Title": "Oto kilka wskazówek, które mogą Ci pomóc.",
        "TipBox_Tip1": "Przeprowadź rozmowę w spokojnym miejscu, abyś mógł się skoncentrować.",
        "TipBox_Tip2": "Odpowiadaj na komputerze z klawiaturą (chyba że wygodnie piszesz na telefonie).",
        "TipBox_Tip3": "Bądź jak najbardziej konkretny i szczegółowy w swoich odpowiedziach. Hubert i rekruterzy chcą Cię dobrze poznać.",
        "TipBox_Tip4": "Poświęć tyle czasu, ile potrzebujesz. Nie ma ograniczeń czasowych.",
        "TipBox_Tip5": "Możesz zrobić przerwę w dowolnym momencie i kontynuować od miejsca, w którym skończyłeś.",
        "TipBox_Tip6": "Bądź sobą i podejdź do rozmowy z Hubertem z takim samym zaangażowaniem, jak do rozmowy z prawdziwą osobą.",
        "CheckAdviceArticle_Text1": "Jeśli chcesz więcej porad, jak odnieść sukces na rozmowie, sprawdź ten",
        "CheckAdviceArticle_Text2": "artykuł",
        "CheckAdviceArticle_Text3": "ze świetnymi radami.",
        "ReadyToGetStarted": "Gotowy do startu?",
        "ORSeparator_Text": "Lub",
        "ButtonText_StartInterviewNow": "Rozpocznij rozmowę",
        "ButtonText_SetReminder": "Nie jestem gotowy, ustaw przypomnienie",
        "PrivacyPolicyText": "Klikając rozpocznij rozmowę, zgadzasz się na",
        "PrivacyPolicyLink": "Politykę prywatności i Regulamin"
    },
    "InterviewCompletedPageInviteEmail": {
        "CompletedAlert_Title": "Dobra robota!",
        "CompletedAlert_Subtitle": "Zakończyłeś rozmowę.",
        "CompletedAlert_Description": "Rekruterzy przeanalizują wszystkie aplikacje i przekażą informację zwrotną e-mailem lub telefonicznie, gdy tylko będą mieli aktualizację.",
        "InterviewNotCompleted": "Ta rozmowa nie została ukończona."
    },
    "HelpCenter": {
        "BannerSection": {
            "Title": "Centrum pomocy",
            "Subtitle": "Znajdź odpowiedzi na najczęściej zadawane pytania o Huberta.",
            "Label_Search": "szukaj często zadawanych pytań",
            "ButtonText_Search": "Szukaj"
        },
        "FAQSection": {
            "Tabs_All": "Wszystkie",
            "Tabs_AboutHubertInterview": "O rozmowie z Hubertem",
            "Tabs_TechnicalSupport": "Wsparcie techniczne"
        },
        "StillHaveQuestion": {
            "Title": "Masz jeszcze pytanie?",
            "Description": "Chętnie pomożemy.",
            "DropUsAEmail": "Napisz do nas na hubert@hubert.ai"
        },
        "Q&ATexts": {
            "AboutHubertInterview": [
                {
                    "q": "Czy mogę odbyć rozmowę telefonicznie?",
                    "a": "Hubert działa obecnie tylko przez czat. Jeśli stan zdrowia uniemożliwia Ci odbycie rozmowy, skontaktuj się bezpośrednio z firmą rekrutującą."
                },
                {
                    "q": "Czy mogę odbyć rozmowę w innym języku?",
                    "a": "W niektórych rozmowach istnieje opcja wyboru języka na początku. Jeśli jej nie ma, zrozumienie języka rozmowy jest prawdopodobnie wymogiem. W razie pytań skontaktuj się z firmą rekrutującą."
                },
                {
                    "q": "Czy będę ukarany za krótkie odpowiedzi?",
                    "a": "Nie, o ile odpowiesz na pytania w odpowiedni sposób. Nie ma minimalnej długości, ale szczegóły często pomagają."
                },
                {
                    "q": "Czy mogę ponownie wykorzystać odpowiedzi z innej rozmowy?",
                    "a": "Tak, możesz ponownie wykorzystać poprzednie odpowiedzi, jeśli jesteś zalogowany do My Hubert i aplikujesz na podobną rolę."
                },
                {
                    "q": "Czy człowiek przeczyta moją rozmowę?",
                    "a": "Tak, nasi klienci są proszeni o ręczne sprawdzanie rozmów."
                },
                {
                    "q": "Ukończyłem rozmowę, co teraz?",
                    "a": "Wyniki są wysyłane do rekrutera. Rekruterzy mogą przejrzeć Twoje odpowiedzi i ocenę Huberta. Na podstawie oceny doradczej i własnego osądu zdecydują, czy zaprosić Cię do kolejnego etapu (telefon, test, rozmowa końcowa)."
                },
                {
                    "q": "Mam pytanie o kolejne kroki, z kim się skontaktować?",
                    "a": "Skontaktuj się z firmą, do której aplikowałeś."
                },
                {
                    "q": "Jak zapewniacie brak uprzedzeń w rekrutacji?",
                    "a": "Ograniczenie uprzedzeń jest kluczowe. Jako maszyna, Hubert jest bardziej spójny niż człowiek. Nasze modele są trenowane przez wielu ekspertów. Hubert nie używa informacji takich jak płeć, wiek czy wygląd, co zmniejsza ryzyko uprzedzeń."
                },
                {
                    "q": "Czy mogę rozmawiać z człowiekiem zamiast z Hubertem?",
                    "a": "Skontaktuj się z firmą, do której aplikowałeś, aby o to zapytać."
                },
                {
                    "q": "Czy Hubert to człowiek?",
                    "a": "Nie, Hubert to komputerowy system wywiadów i analizy."
                },
                {
                    "q": "Czy mogę zmienić odpowiedzi później?",
                    "a": "Nie, tak jak w prawdziwej rozmowie, nie można cofnąć odpowiedzi po ich wysłaniu."
                },
                {
                    "q": "Jak odnieść sukces w rozmowie z Hubertem?",
                    "a": "Czytaj uważnie pytania. Postępuj zgodnie z instrukcjami. Podawaj prawdziwe przykłady i bądź szczery."
                },
                {
                    "q": "Potrzebuję pracy, z kim się skontaktować?",
                    "a": "Skontaktuj się z firmą, do której aplikowałeś."
                },
                {
                    "q": "Ukończyłem rozmowę, ale nic nie słyszałem. Co robić?",
                    "a": "O kolejnych krokach decydują rekruterzy. Czas odpowiedzi zależy m.in. od liczby kandydatów i tempa procesu. Jeśli minęło trochę czasu, skontaktuj się z rekruterem, aby sprawdzić status. W My Hubert możesz też przejrzeć swoje odpowiedzi i wskazówki, jak je wzmocnić na przyszłość."
                },
                {
                    "q": "Mam doświadczenie, ale nie dostałem pracy. Dlaczego?",
                    "a": "To często kwestia dopasowania do konkretnych potrzeb roli i porównania z innymi kandydatami, nie oceny Twojej wartości. Jeśli możesz, poproś firmę o krótką informację zwrotną. W My Hubert znajdziesz swoje odpowiedzi i wskazówki, co doprecyzować lub pokazać bardziej konkretnie następnym razem."
                },
                {
                    "q": "Ile trwa rozmowa?",
                    "a": "Zależy to od liczby pytań. Spodziewaj się od 10 do 25 minut. Nie spiesz się. Możesz zrobić przerwę."
                },
                {
                    "q": "Gdzie mogę przeczytać o przetwarzaniu danych?",
                    "a": "https://www.hubert.ai/candidate-privacy-policy"
                }
            ],
            "TechnicalSupport": [
                {
                    "q": "Dlaczego nie widzę moich poprzednich rozmów?",
                    "a": "Upewnij się, że użyłeś tego samego adresu email do aplikacji i logowania do My Hubert (również przy logowaniu Google). Spróbuj utworzyć konto z adresem email użytym w aplikacji."
                },
                {
                    "q": "Dlaczego nie otrzymałem emaila z rozmową?",
                    "a": "Sprawdź folder spam. Możesz też dodać hubert@hubert.ai do kontaktów. Lub utwórz konto na Mojm Hubercie (używając adresu z aplikacji), aby znaleźć tam link."
                },
                {
                    "q": "Nie mogę znaleźć linku w emailu.",
                    "a": "Sprawdź folder spam. Lub zaloguj się do My Hubert i przejdź do 'Moje rozmowy', aby znaleźć link."
                },
                {
                    "q": "Czy rozmowa działa na urządzeniach mobilnych?",
                    "a": "Tak! Ale jeśli wolisz pisać na komputerze, użyj komputera."
                },
                {
                    "q": "Rozmowa nie działa, co robić?",
                    "a": "Przykro nam to słyszeć. Wyślij email na hubert@hubert.ai, a pomożemy."
                },
                {
                    "q": "Chcę usunąć konto, co robić?",
                    "a": "Wyślij email na hubert@hubert.ai, a pomożemy."
                },
                {
                    "q": "Rozmowa została przerwana, jak wrócić?",
                    "a": "Kliknij link w emailu z zaproszeniem lub zaloguj się do My Hubert i wybierz rozmowę w 'Moje rozmowy'."
                }
            ]
        }
    },
    "LearnWithHubert": {
        "BannerSection": {
            "Title": "Ucz się z Hubertem",
            "Subtitle": "Dowiedz się, jak zwiększyć swoje szanse w rekrutacji i lepiej radzić sobie w pracy.",
            "Label_Search": "szukaj poradników",
            "ButtonText_Search": "Szukaj"
        },
        "TabSelector": {
            "MyFeed": "Mój kanał",
            "InterviewGuides": "Przewodniki rozmów",
            "CareerGuides": "Przewodniki kariery"
        },
        "NewestOnTheFeed": "Najnowsze",
        "PickedForMe": "Wybrane dla Ciebie",
        "InterviewGuides": "Przewodniki rozmów",
        "CareerGuides": "Przewodniki kariery"
    },
    "Article": {
        "ButtonText_BackToAllArticles": "Wróć do wszystkich artykułów"
    },
    "ForgotPassword": {
        "ResetLinkAlert_Title": "Zresetuj hasło",
        "ResetLinkAlert_Subtitle": "Kliknij link wysłany na Twój email, aby ustawić nowe hasło.",
        "PasswordNotSetAlert_Message": "Hasło nieustawione, zaloguj się używając ",
        "ResetYourPassword": {
            "MainTitle": "Zobacz wyniki swojej rozmowy z Hubertem",
            "Subtitle": "Zaloguj się, aby zobaczyć wyniki, opinie i więcej.",
            "FormSectionTitle": "Zresetuj hasło",
            "Label_NewPassword": "Nowe hasło",
            "Label_ConfirmNewPassword": "Potwierdź nowe hasło",
            "Error_NewPassword_Required": "Wprowadź nowe hasło.",
            "Error_Password_6_Characters": "Hasło musi mieć co najmniej 6 znaków.",
            "Error_ConfirmNewPassword_Required": "Potwierdź nowe hasło.",
            "Error_ConfirmNewPassword_NotMatch": "Hasła nie pasują.",
            "Error_MalformedResetUrl": "Nieprawidłowy kod. Spróbuj ponownie.",
            "Error_ResetPasswordFailed": "Problem z resetowaniem. Spróbuj ponownie.",
            "Error_WeakPassword": "Hasło musi mieć co najmniej 6 znaków.",
            "Error_InvalidCode_Title": "Żądanie wygasło lub jest nieprawidłowe.",
            "Error_InvalidCode_Subtitle": "Spróbuj zresetować hasło ponownie.",
            "ButtonText_SetNewPassword": "Ustaw hasło i zaloguj się",
            "ButtonText_RememberYourPassword": "Pamiętasz hasło?",
            "ButtonText_SignInInstead": "Zaloguj się"
        }
    },
    "PageNotFound": {
        "Title": "Strona nie znaleziona",
        "Description": "Nie możemy znaleźć strony, której szukasz.",
        "ButtonText_GoToDashboard": "Idź do pulpitu",
        "ButtonText_GoToLogin": "Idź do logowania"
    },
    "OldInterviewRedirectionModal": {
        "DescriptionLine1": "Ponowne wykorzystanie odpowiedzi nie jest jeszcze dostępne dla tej rozmowy. Spodziewamy się, że będzie to możliwe wkrótce, ale możesz odbyć rozmowę teraz.",
        "DescriptionLine2": "Przejdź do rozmowy, klikając przycisk poniżej.",
        "ButtonText_TakeMeToTheInterview": "Zabierz mnie do rozmowy"
    },
    "UnsubscribeFromEmails": {
        "Title": "Jesteś pewien?",
        "Subtitle": "Przestaniesz otrzymywać od nas emaile dotyczące tej pracy:",
        "SelectTheReason": "Wybierz powód.",
        "ReasonText1": "Znalazłem inną pracę.",
        "ReasonText2": "Nie jestem już zainteresowany.",
        "ReasonText3": "Inne",
        "ButtonText_Unsubscribe": "Wypisz się",
        "Placeholder_YourReason": "Twój powód",
        "Success_Title": "Pomyślnie wypisano z powiadomień o tej pracy.",
        "Loading": "Ładowanie...",
        "Error_YourReason_Required": "Podaj powód.",
        "Error_ServerIssue": "Wypisanie nie powiodło się z powodu błędu serwera."
    },
    "SocialLoginCallback": {
        "ButtonText_TryAgain": "Spróbuj ponownie"
    },
    "Outreach": {
        "CandidateNotFound": "Nie znaleziono kandydata",
        "CandidateNotFoundDesc": "Nie mogliśmy znaleźć szczegółów rozmowy, których szukasz.",
        "InterviewEnded": "Rozmowa zakończona",
        "InterviewEndedDesc1": "Ta sesja rozmowy dobiegła końca lub nie jest już dostępna.",
        "InterviewEndedDesc2": "Dziękujemy za poświęcony czas. Jeśli masz pytania, skontaktuj się z zespołem rekrutacyjnym.",
        "ReadyTitle": "Gotowy na rozmowę, {{firstName}}?",
        "InvitationDesc": "Hubert w imieniu {{companyName}} zaprasza Cię na rozmowę na czacie. Zajmie to około 1–2 minuty.",
        "Button_StartChat": "Rozpocznij rozmowę na czacie",
        "CancelNotice": "Rozpoczęcie tutaj anuluje zaplanowaną rozmowę telefoniczną w sprawie tego stanowiska.",
        "PreferNotToContinue": "Nie chcesz kontynuować?",
        "DeclineLabel": "Nie jestem zainteresowany tą ofertą. Proszę nie dzwonić ani nie pisać do mnie więcej w tej sprawie.",
        "Button_ConfirmAndDecline": "Potwierdź i odrzuć",
        "Processing": "Przetwarzanie...",
        "Toast_DeclineSuccess": "Rozmowa została odrzucona.",
        "Toast_CancelVoiceInfo": "Połączenie anulowane. Funkcja będzie dostępna wkrótce.",
        "Toast_CancelError": "Nie udało się anulować rozmowy. Spróbuj ponownie.",
        "Footer_WithdrawConsent": "Możesz w dowolnym momencie wycofać zgodę. Więcej informacji znajdziesz w ",
        "Footer_PrivacyPolicySuffix": "polityce prywatności {{companyName}}",
        "Footer_And": " oraz ",
        "Footer_HubertPrivacyLink": "Polityce prywatności Huberta oraz Regulaminie",
        "Chat_InterviewWith": "Rozmowa z {{companyName}}",
        "Chat_StatusConnected": "Połączono",
        "Chat_StatusError": "Błąd",
        "Chat_StatusDisconnected": "Rozłączono",
        "Chat_StatusConnecting": "Łączenie...",
        "Chat_ReadyToStart": "Gotowy do rozpoczęcia rozmowy?",
        "Chat_ButtonStart": "Rozpocznij rozmowę",
        "Chat_SayHello": "Napisz „cześć”, aby rozpocząć.",
        "Chat_EmptyState": "Wyślij wiadomość, aby rozpocząć rozmowę.",
        "Chat_SelectLanguage": "Wybierz język",
        "Chat_Placeholder": "Wpisz wiadomość...",
        "Chat_ButtonSend": "Wyślij",
        "Chat_ButtonBack": "Wstecz",
        "LoadingCandidateDetails": "Ładowanie danych kandydata...",
        "FetchingCandidateDetails": "Pobieranie danych kandydata...",
        "Chat_StatusReady": "Oczekiwanie na połączenie...",
        "Chat_ForbiddenError": "Ta rozmowa na czacie nie jest już dostępna.",
        "Chat_GeneralError": "Nie udało się rozpocząć czatu. Spróbuj ponownie później.",
        "Chat_SelectUiLanguage": "Język menu",
        "Chat_InterviewTitle": "Rozmowa kwalifikacyjna"
    }
}
